import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { CmsConfig, ConfigModule, DeferLoadingStrategy, I18nModule, provideConfig } from '@spartacus/core';
import { DynamicFormsModule } from '../../dynamic-forms/dynamic-forms.module';
import { MyaccAddressModalComponent } from './myacc-address-modal/myacc-address-modal.component';
// tslint:disable-next-line: max-line-length
import { BillingAddressModalComponent } from './myaccount-billing-address/billing-address-modal/billing-address-modal.component';
import { MyaccountPersonalinfoAddressComponent } from './myaccount-personalinfo-address.component';
// tslint:disable-next-line: max-line-length
import { MatRadioModule } from '@angular/material/radio';
import { MatTooltipModule } from '@angular/material/tooltip';
import { LaunchDialogModalLayoutConfig } from 'src/app/dialog/custom-launch-dialog-config';
import { RequestNewDeliveryAddrModalComponent } from './request-new-delivery-addr-modal/request-new-delivery-addr-modal.component';

@NgModule({
  imports: [
    CommonModule,
    I18nModule,
    MatIconModule,
    MatTooltipModule,
    MatRadioModule,
    ReactiveFormsModule,
    DynamicFormsModule,
    I18nModule,
    ConfigModule.withConfig({
      cmsComponents: {
        MyAccountAddressesComponent: {
          component: MyaccountPersonalinfoAddressComponent,
          deferLoading: DeferLoadingStrategy.DEFER,
        },
      },
    } as CmsConfig),
    MyaccountPersonalinfoAddressComponent,
    BillingAddressModalComponent,
    MyaccAddressModalComponent,
    RequestNewDeliveryAddrModalComponent,
  ],
  providers: [
    provideConfig({
      ...LaunchDialogModalLayoutConfig.MyAccounts,
    }),
  ],
})
export class MyaccountPersonalinfoAddressModule {}
